import type { IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

export enum TagsListSearchKey {
  SEARCH_QUERY = 'searchQuery',
}

export type TagsListFiltersState = {
  searchQuery: string;
  includeInactive: boolean;
};

export interface TagsListRouteParams {
  integrationType: IntegrationType;
}
